var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuArrow = function SvgMenuArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M8.845 2.806a.5.5 0 1 0-.69.724l4.168 3.97H2.5a.5.5 0 1 0 0 1h9.823l-4.168 3.97a.5.5 0 1 0 .69.724l4.946-4.711a.66.66 0 0 0 .2-.387.5.5 0 0 0 0-.193.66.66 0 0 0-.2-.386z"
  })));
};
export default SvgMenuArrow;